import { Box, Typography } from '@mui/material';
import InfoBox from 'components/info-box';
import React from 'react';
import { useScenarioState } from 'views/bluviu-nutrition/features/scenarios/context/scenario-context';

const ScenarioProgress: React.FC<{}> = () => {
  const {
    scenarioStatusQuery: { data: scenarioStatus },
  } = useScenarioState();

  if (!scenarioStatus?.scenarioIsRunning) return;

  return (
    <InfoBox variant={'light'}>
      <Box display={'flex'} flexDirection={'column'} gap={1}>
        <Typography>Scenario in progress</Typography>
        <Typography>
          You are free to leave this page while the scenario is running. This may take a few minutes depending on the complexity of
          your site data.
        </Typography>
      </Box>
    </InfoBox>
  );
};

export default React.memo(ScenarioProgress);
